import {
  getCohortIntegrationData,
  trackIntegrationEvent,
} from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
} from 'generated/graphql';
import { CohortIntegrationUserIdentifiersForm } from 'modules/ui/Settings/Integrations/CohortIntegrationUserIdentifiersForm';
import useCreateIntegrationEdgeServer from 'v2/core/repository/edge-server/integrations';
import { useGetUser } from 'v2/core/services/user';

interface CohortIntegrationFormModalProps {
  channelType: IntegrationChannelType;
}

export const CohortIntegrationFormModal = ({
  channelType,
}: CohortIntegrationFormModalProps) => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const { createIntegration } = useCreateIntegrationEdgeServer({
    tenantID,
    direction: IntegrationDirection.Inbound,
    channel: channelType,
    integrationType: IntegrationType.Cohorts,
    createdByUser: userID,
    inputData: getCohortIntegrationData(channelType),
    onCompleted: () => {
      trackIntegrationEvent({
        eventName: 'Integration Added',
        integrationChannelType: channelType,
      });
    },
  });

  return (
    <CohortIntegrationUserIdentifiersForm
      channelType={channelType}
      onSubmit={createIntegration}
    />
  );
};
